import type { ReactNode } from 'react';
import { assets } from '@/assets';
import { strings } from '@/content/strings';
import { ImageButton } from './ImageButton';
import styles from './TopBar.module.css';

interface TopBarProps {
  onBack?: () => void;
  onSettings?: () => void;
  /** Centre content, usually the logo. */
  children?: ReactNode;
}

/** Standard screen header: back on the left, settings on the right. */
export function TopBar({ onBack, onSettings, children }: TopBarProps) {
  return (
    <nav className={styles.bar}>
      <ImageButton
        image={assets.ui.buttons.back}
        label={strings.common.back}
        size={48}
        onClick={onBack}
      />
      <div className={styles.center}>{children}</div>
      <ImageButton
        image={assets.ui.buttons.settings}
        label={strings.common.settings}
        size={48}
        onClick={onSettings}
      />
    </nav>
  );
}
